<ng-template
  #selectWithHeaderTextTemplate
  let-headerText="headerText"
  let-id="id"
  let-isLoading="isLoading"
  let-searchPlaceholder="searchPlaceholder"
  let-searchText="searchText"
  let-searchable="searchable">
  <div
    class="ng-dropdown-header__title"
    (click)="emitClose()"
    (keydown.enter)="emitClose()"
    (keydown.space)="emitClose()">
    {{ headerText }}
    <fa-icon
      aria-label="Close"
      class="ng-dropdown-header__close"
      icon="xmark" />
  </div>
  @if (searchable === true) {
    <div class="ng-dropdown-header__search">
      <bn-web-ui-input
        inputName="Dropdown search"
        size="xs"
        [id]="id + 'header-search-1'"
        [ngModel]="searchText"
        [options]="{
          rightAddons: [{ icon: 'search' }],
        }"
        [placeholder]="searchPlaceholder ?? ''"
        [readonly]="isLoading"
        (ngModelChange)="emitFilterChange($event)" />
    </div>
  }
</ng-template>
